import { IImageProps } from 'native-base'
import React from 'react'

import { DESIGN_SYSTEM_THEME } from '../../../constants/config'
import { SuccessImageProsperia } from '../Success/SuccessImageProsperia'

type Props = Omit<IImageProps, 'width' | 'height'> & {
  size: number
}

export const UpdateAppImage: React.FC<Props> = ({ size }) => {
  switch (DESIGN_SYSTEM_THEME) {
    case 'prosperia':
      return <SuccessImageProsperia size={size} />
    default:
      return <SuccessImageProsperia size={size} />
  }
}
